module.exports = __webpack_public_path__ + "static/media/puzzle-25-bg.4119a5d8.svg";